import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=2db57ea0&scoped=true"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=2db57ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db57ea0",
  null
  
)

export default component.exports